export default __webpack_public_path__ + "img/bg_studios-9832a609c0fcf101fdbf10c161b9777c.png";